export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			companyReportLoadStatuses: [
				{name: "PENDING", value: "Pending"},
				{name: "PENDING TRANSLATED", value: "Pending Translated"},
				{name: "PROCESSING", value:"Processing"},
				{name: "COMPLETED", value: "Completed"},
				{name: "ERROR", value:"Error"}
			],
		}
	}
};